<template>
  <div id="app">
    <div>
      <confirm ref="confirm"></confirm>
      <loader v-model="statusval.loading"></loader>
      <arksnackbar v-model="statusval"></arksnackbar>
      <yetkidialog ref="yetkidialog"></yetkidialog>
    </div>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>
                <v-layout align-center>
                  <v-img
                    v-if="logo != null"
                    :src="getImgUrl(logo)"
                    height="50px"
                    width="100px"
                    contain
                  >
                  </v-img>
                  &nbsp;
                  {{ title }}
                </v-layout>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom left v-if="menuitems != undefined">
                <template v-slot:activator="{ on }">
                  <v-btn dark icon v-on="on">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-tile
                    v-for="(item, i) in menuitems"
                    :key="i"
                    @click="menuClick(i)"
                  >
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container
            fluid
            v-if="tarihfield == undefined || tarihfield == false"
          >
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <v-layout align-center justify-start row fill-height>
                    <v-form
                      ref="formaktarim"
                      id="formaktarim"
                      method="post"
                      enctype="multipart/form-data"
                      v-model="valid"
                      lazy-validation
                    >
                      <input
                        hidden
                        type="file"
                        id="files"
                        ref="files"
                        multiple
                        v-on:change="handleFilesUpload()"
                      />
                    </v-form>
                    <v-btn
                      :loading="false"
                      :disabled="false"
                      color="info"
                      dark
                      @click="addFiles()"
                    >
                      <v-icon color="white" left>attach_file</v-icon>
                      {{ $t("Select-Transfer-File") }}
                    </v-btn>

                    <div v-show="load2">
                      <v-btn
                        small=""
                        fab
                        @mouseenter="tooltip = true"
                        @mouseleave="tooltip = false"
                        ref="fab"
                        @click="btnSubmitFiles()"
                        color="info"
                        dark
                      >
                        <v-icon>redo</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>{{ $t("Transfer-Selected") }}</span>
                      </v-tooltip>
                    </div>

                    <!-- <div v-if="status.loading">
                      <v-layout>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-layout>
                    </div> -->
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md4> </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-alert
                    :value="true"
                    :color="alertcolor"
                    icon="check_circle"
                    outline
                  >
                    {{ alertmessage }}
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
          <v-container fluid v-if="tarihfield == true">
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <v-form ref="formtarih" v-model="valid" lazy-validation>
                    <tarihcomp
                      :etiket="$t('Select-Date')"
                      :detaygizle="false"
                      v-model="date"
                      v-bind:defaultvalue="'ok'"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    ></tarihcomp>
                  </v-form>
                </v-flex>

                <v-flex>
                  <v-layout align-start="" justify-center column fill-height>
                    <div v-if="load1">
                      <v-btn
                        small=""
                        @mouseenter="tooltip = true"
                        @mouseleave="tooltip = false"
                        ref="fab"
                        @click="btnAktar()"
                        color="info"
                        fab
                        dark
                      >
                        <v-icon>reply_all</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Rezervasyonları Aktar</span>
                      </v-tooltip>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>
          <!-- <div class="large-12 medium-12 small-12 cell">
          <template v-for="(file, key) in files">
            <v-chip :key="file.key" close @input="removeFile(key)">
              <strong>{{ file.name }}</strong>&nbsp;
            </v-chip>
          </template>
        </div> -->

          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>{{
                  $t("Imported-Hotel-Data")
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  flat=""
                  solo-inverted=""
                  hide-details
                  v-model="search3"
                  :label="$t('Search')"
                  append-icon="search"
                  
                >
                </v-text-field>
              </v-toolbar>

              <v-card>
                <v-data-table
                  :headers="headers"
                  :rows-per-page-items="[20, 500]"
                  :items="itemsok"
                  :search="search3"
                >
                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.pnrNo }}</td>
                      <td class="text-xs-left">{{ props.item.DisId }}</td>
                      <td class="text-xs-left">{{ props.item.aciklama }}</td>
                      <v-btn icon class="mx-0" @click="git(props.item)">
                        <v-icon color="teal">search</v-icon>
                      </v-btn>
                    </tr>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="warning"
                  >
                    {{ $t("No-records-searched-for", { value: search3 }) }}
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-toolbar size="120px" dark color="red">
                <v-toolbar-title>{{ $t("Error-Hotel-Data") }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  flat=""
                  solo-inverted=""
                  hide-details
                  v-model="search4"
                  :label="$t('Search')"
                  append-icon="search"
                >
                </v-text-field>
              </v-toolbar>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :rows-per-page-items="[20, 500]"
                  :items="itemsno"
                  :search="search4"
                >
                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.pnrNo }}</td>
                      <td class="text-xs-left">{{ props.item.DisId }}</td>
                      <td class="text-xs-left">{{ props.item.aciklama }}</td>
                      <v-btn
                        v-if="props.item.pnrNo > 0"
                        icon
                        class="mx-0"
                        @click="git(props.item)"
                      >
                        <v-icon color="teal">search</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="props.item.saticiEntegrasyon.length > 0"
                        icon
                        class="mx-0"
                        @click="saticiDialogAc(props.item)"
                      >
                        <v-icon color="teal">add</v-icon>
                      </v-btn>
                    </tr>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="warning"
                  >
                    {{ $t("No-records-searched-for", { value: search4 }) }}
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card>
    </v-app>

    <customdialog v-model="saticidDialog" title="Satıcı Eşleştirme" max-width=700px>
   
        <v-combobox
          v-model="EslestirmeTipi"
          :items="[
            { Key: 0, Text: 'Mevcut Satıcı ile eşleştir' },
            { Key: 1, Text: 'Yeni Satıcı Oluştur' },
          ]"
          item-text="Text"
          label="Eşleştirmede Kullanılacak Yöntemi seçiniz"
        ></v-combobox>

      <div v-if="EslestirmeTipi.Key == 0">
       
        <div><strong> Mevcut Kayıtlı Bir Satıcı seçiniz. </strong></div>
        
        <saticiara
          ref="saticiara"
          v-model="Satici"
          :tip="SaticiTip"
        ></saticiara>

     

        <div><strong>Entegrasyondan Gelen Satıcı Bilgisi</strong></div>

      <hr></hr>
      <div><strong>SaticiTipi      : </strong>{{aktifSatici.SaticiTipi  }}</div>
		  <div><strong>Kod             : </strong>{{aktifSatici.Kod         }}</div>
		  <div><strong>Isim            : </strong>{{aktifSatici.Isim        }}</div>
		  <div><strong>Adres           : </strong>{{aktifSatici.Adres       }}</div>
		  <!-- <div><strong>PK              : </strong>{{aktifSatici.PK          }}</div> -->
		  <div><strong>Ulke            : </strong>{{aktifSatici.Ulke        }}</div>
		  <div><strong>Sehir           : </strong>{{aktifSatici.Sehir       }}</div>
		  <!-- <div><strong>Yer             : </strong>{{aktifSatici.Yer         }}</div> -->
      <!-- <div><strong>SaticiKonumu    : </strong>{{aktifSatici.SaticiKonumu}}</div> -->
		  <!-- <div><strong>Yetkili         : </strong>{{aktifSatici.Yetkili     }}</div> -->
      <!-- <div><strong>Web             : </strong>{{aktifSatici.Web         }}</div> -->
      <!-- <div><strong>HavaAlani       : </strong>{{aktifSatici.HavaAlani   }}</div> -->
      <!-- <div><strong>VDaire          : </strong>{{aktifSatici.VDaire      }}</div> -->
      <!-- <div><strong>VNo             : </strong>{{aktifSatici.VNo         }}</div> -->
      <div><strong>Tel1            : </strong>{{aktifSatici.Tel1        }}</div>
      <div><strong>Tel2            : </strong>{{aktifSatici.Tel2        }}</div>
      <div><strong>Fax             : </strong>{{aktifSatici.Fax         }}</div>
      <div><strong>Teleks          : </strong>{{aktifSatici.Teleks      }}</div>
      <div><strong>Email           : </strong>{{aktifSatici.Email       }}</div>
      <div><strong>GSM             : </strong>{{aktifSatici.GSM         }}</div>
      <div><strong>Ic_Dis          : </strong>{{aktifSatici.Ic_Dis      }}</div>
      <!-- <div><strong>Aciklamalar     : </strong>{{aktifSatici.Aciklamalar }}</div> -->
      </div>

      <div v-if="EslestirmeTipi.Key == 1">
        <!-- <v-text-field v-model="aktifSatici.SaticiTipi  " label='SaticiTipi  ' ></v-text-field> -->
        <v-text-field
          v-model="aktifSatici.Kod"
          label="Kod         "
        ></v-text-field>
        <v-text-field
          v-model="aktifSatici.Isim"
          label="Isim        "
        ></v-text-field>
        <v-text-field
          v-model="aktifSatici.Adres"
          label="Adres       "
        ></v-text-field>
        <!-- <v-text-field v-model="aktifSatici.PK          " label='PK          ' ></v-text-field> -->
        <v-text-field
          v-model="aktifSatici.Ulke"
          label="Ulke        "
        ></v-text-field>
        <v-text-field
          v-model="aktifSatici.Sehir"
          label="Sehir       "
        ></v-text-field>
        <!-- <v-text-field v-model="aktifSatici.Yer         " label='Yer         ' ></v-text-field> -->
        <!-- <v-text-field v-model="aktifSatici.SaticiKonumu" label='SaticiKonumu' ></v-text-field> -->
        <!-- <v-text-field v-model="aktifSatici.Yetkili     " label='Yetkili     ' ></v-text-field> -->
        <!-- <v-text-field v-model="aktifSatici.Web         " label='Web         ' ></v-text-field> -->
        <!-- <v-text-field v-model="aktifSatici.HavaAlani   " label='HavaAlani   ' ></v-text-field> -->
        <!-- <v-text-field v-model="aktifSatici.VDaire      " label='VDaire      ' ></v-text-field> -->
        <!-- <v-text-field v-model="aktifSatici.VNo         " label='VNo         ' ></v-text-field> -->
        <v-text-field
          v-model="aktifSatici.Tel1"
          label="Tel1        "
        ></v-text-field>
        <!-- <v-text-field v-model="aktifSatici.Tel2        " label='Tel2        ' ></v-text-field> -->
        <!-- <v-text-field v-model="aktifSatici.Fax         " label='Fax         ' ></v-text-field> -->
        <!-- <v-text-field v-model="aktifSatici.Teleks      " label='Teleks      ' ></v-text-field> -->
        <v-text-field
          v-model="aktifSatici.Email"
          label="Email       "
        ></v-text-field>
        <v-text-field
          v-model="aktifSatici.GSM"
          label="GSM         "
        ></v-text-field>
        <v-text-field
          v-model="aktifSatici.Ic_Dis"
          label="Ic_Dis      "
        ></v-text-field>
        <!-- <v-text-field v-model="aktifSatici.Aciklamalar " label='Aciklamalar ' ></v-text-field> -->
      </div>
      <template slot="btn">
        <v-btn color="primary" flat @click="dialogOk">{{$t("save_button")}}</v-btn>
      </template>
    </customdialog>
  </div>
</template>

<script>
import confirm from "@/components/app/coper/comp/confirm.vue";
import loader from "@/components/app/coper/comp/loader.vue";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
import customdialog from "@/components/app/coper/comp/customdialog.vue";
import logoo from "../../../../assets/control";
import helpers from "@/components/app/customcomp/helpers.js";

import tool from "../../coper/tools";
import auth from "../../../../api/auth";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tarihcomp from "@/components/app/customcomp/tarihim";
import saticiara from "@/components/app/coper/comp/saticiara.vue";

export default {
  props: ["value", "title", "status", "logo", "tarihfield", "menuitems"],
  data() {
    return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },

      itemsairlinelist: [],
      headers: [
        {
          text: this.$t("PNR-No"),
          value: "pnrNo",
        },
        {
          text: "Dış Id",
          value: "DisId",
        },
        {
          text: this.$t("Status"),
          value: "aciklama",
        },
      ],
      itemsno: [],
      itemsok: [],
      alertcolor: "red",
      alertmessage: this.$t("file-has-been-chosen"),
      search3: "",
      search4: "",
      EslestirmeTipi: { Key: 0, Text: "Mevcut Satıcı ile eşleştir" },
      saticidDialog: false,
      Satici: {},
      SaticiTip: 0,

      aktifPNR: null,
      aktifSatici: {
        SaticiTipi: 1,
        Kod: "",
        EntKod: "",
        Isim: "",
        Adres: "",
        PK: "",
        Ulke: "",
        Sehir: "",
        Yer: "",
        SaticiKonumu: "",
        Yetkili: "",
        Web: "",
        HavaAlani: 0,
        VDaire: "",
        VNo: "",
        Tel1: "",
        Tel2: "",
        Fax: "",
        Teleks: "",
        Email: "",
        GSM: "",
        Ic_Dis: 0,
        Aciklamalar: "",
      },

      files: [],
      valid: true,
      load2: false,
      load3: false,
      butondurum: true,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      tooltip: false,
      el: null,
      date: null,
    };
  },
  components: {
    confirm,
    loader,
    arksnackbar,
    customdialog,
    yetkidialog,
    tarihcomp,
    saticiara,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    statusval: {
      get: function () {
        if (this.status == null) {
          return tool.NewSatatus();
        } else {
          return this.status;
        }
      },
    },
  },

  watch: {
    model(val) {
      this.watchmodel(val);
    },
  },
  mounted() {
    this.el = this.$refs.fab.$el;

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    if (this.sayfayetki.Status == true) {
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },

  methods: {
    getImgUrl(img) {
      return logoo.logoControl(img);
    },

    menuClick(index) {
      this.$emit("menuclick", index);
    },

    watchmodel(val) {
      this.itemsok = [];
      this.itemsno = [];

      if (val) {
        val.forEach((element) => {
          if (element.basarili) {
            this.itemsok.push(element);
            //aktarilan = aktarilan + 1
          } else {
            this.itemsno.push(element);
          }
        });
      }
    },
    handleFilesUpload() {
      this.files = [];

      let uploadedFiles = this.$refs.files.files;

      if (uploadedFiles.length > 0) {
        this.alertcolor = "success";
        this.alertmessage =
          "Toplam " +
          uploadedFiles.length +
          " " +
          this.$t("pcs-of-files-selected");
        this.load2 = true;

        for (var i = 0; i < uploadedFiles.length; i++) {
          this.files.push(uploadedFiles[i]);
        }
      } else {
        this.alertmessage = this.$t("file-has-been-chosen");
        this.alertcolor = "red";
        this.load2 = false;
      }
    },
    btnSubmitFiles() {
      this.$refs.confirm
        .open(
          "Otel Rezervasyon Aktarımı",
          this.title + " Dosyaları Aktarılsın mı?",
          {
            color: "red",
          }
        )
        .then((confirm) => {
          if (confirm == true) {
            this.$emit("submitfile", this.files);
          }
        });
    },

    btnAktar() {
      this.$refs.confirm
        .open("Otel Rezervasyon Aktarımı", this.title + " Aktarılsın mı?", {
          color: "red",
        })
        .then((confirm) => {
          if (confirm == true) {
            this.$emit("aktar", this.date);
          }
        });
    },

    removeFile(key) {
      this.files.splice(key, 1);
    },
    removeAllFiles() {
      this.$refs.confirm
        .open("Dosya Sil", this.$t("Delete-the-Files"), {
          color: "red",
        })
        .then((confirm) => {
          if (confirm == true) {
            this.files = [];
          }
        });
    },

    addFiles() {
      this.$refs.files.click();
    },

    load1() {
      return this.files.length <= 0;
    },
    git: git,
    saticiDialogAc: saticiDialogAc,
    dialogOk: dialogOk,
  },
};

function git(v) {
  let url = "#/coper/rezervasyon/index/id?" + "islem=get&PNR_No=" + v.pnrNo;
  window.open(url, "_blank");
}

function dialogOk() {
  let prm = {
    SaticiTipi: this.SaticiTip,
    SaticiEntegrasyon: this.aktifSatici,
    SaticiMapTip: this.EslestirmeTipi.Key,
    SaticiKodu: this.Satici.kod,
  };

  this.status.loading = true;
  tool.api_post(this, "Coper/SaticiMap", prm).then(
    (response) => {
      //this.items = response.body;

      if (response.body.Status == true) {
        this.status.loading = false;
        this.saticidDialog = false;
      } else {
        this.status.loading = false;
        this.status.text = response.body.ErrorList[0];
        this.status.show = true;
      }
    },
    (response) => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function saticiDialogAc(v) {
  this.aktifPNR = v;
  this.EslestirmeTipi = { Key: 0, Text: "Mevcut Satıcı ile eşleştir" };
  this.SaticiTip = v.saticiEntegrasyon[0].SaticiTipi;

  this.aktifSatici.SaticiTipi = v.saticiEntegrasyon[0].SaticiTipi;
  this.aktifSatici.Kod = v.saticiEntegrasyon[0].Kod;
  this.aktifSatici.EntKod = v.saticiEntegrasyon[0].Kod;
  this.aktifSatici.Isim = v.saticiEntegrasyon[0].Isim;
  this.aktifSatici.Adres = v.saticiEntegrasyon[0].Adres;
  this.aktifSatici.PK = v.saticiEntegrasyon[0].PK;
  this.aktifSatici.Ulke = v.saticiEntegrasyon[0].Ulke;
  this.aktifSatici.Sehir = v.saticiEntegrasyon[0].Sehir;
  this.aktifSatici.Yer = v.saticiEntegrasyon[0].Yer;
  this.aktifSatici.SaticiKonumu = v.saticiEntegrasyon[0].SaticiKonumu;
  this.aktifSatici.Yetkili = v.saticiEntegrasyon[0].Yetkili;
  this.aktifSatici.Web = v.saticiEntegrasyon[0].Web;
  this.aktifSatici.HavaAlani = v.saticiEntegrasyon[0].HavaAlani;
  this.aktifSatici.VDaire = v.saticiEntegrasyon[0].VDaire;
  this.aktifSatici.VNo = v.saticiEntegrasyon[0].VNo;
  this.aktifSatici.Tel1 = v.saticiEntegrasyon[0].Tel1;
  this.aktifSatici.Tel2 = v.saticiEntegrasyon[0].Tel2;
  this.aktifSatici.Fax = v.saticiEntegrasyon[0].Fax;
  this.aktifSatici.Teleks = v.saticiEntegrasyon[0].Teleks;
  this.aktifSatici.Email = v.saticiEntegrasyon[0].Email;
  this.aktifSatici.GSM = v.saticiEntegrasyon[0].GSM;
  this.aktifSatici.Ic_Dis = v.saticiEntegrasyon[0].Ic_Dis;
  this.aktifSatici.Aciklamalar = v.saticiEntegrasyon[0].Aciklamalar;

  this.saticidDialog = true;
}
</script>